var React = require('react');

class LoginHiddenFields extends React.Component {

    render() {
        const props = this.props;
        return (
            <div className="form-group">
                <input type="hidden" name="redirect_uri" value={props.redirectUrl} />
                <input type="hidden" name="client_id" value={props.clientId} />
                <input type="hidden" name="realm_id" value={props.realmId} />
                <input type="hidden" name="user_type" value={props.userType} />
                <input type="hidden" name="response_type" value={props.responseType} />
                <input type="hidden" name="locale_id" id="locale_id" value={props.localeId} />
                <input type="hidden" name="encrypted_code" id="encrypted_code" />
            </div>
        )
    }
}
module.exports = LoginHiddenFields;
